define("@latermedia/ember-later-analytics/components/ui/meter-list-loading", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div data-test-id="meter-list-loading">
    <div class="cCH--loading cCH--loading--line"></div>
    <div class="cCH--loading cCH--loading--line"></div>
    <div class="cCH--loading cCH--loading--line"></div>
    <div class="cCH--loading cCH--loading--line"></div>
    <div class="cCH--loading cCH--loading--line"></div>
  </div>
  
  */
  {
    "id": "RfYq/DLj",
    "block": "[[[10,0],[14,\"data-test-id\",\"meter-list-loading\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"cCH--loading cCH--loading--line\"],[12],[13],[1,\"\\n  \"],[10,0],[14,0,\"cCH--loading cCH--loading--line\"],[12],[13],[1,\"\\n  \"],[10,0],[14,0,\"cCH--loading cCH--loading--line\"],[12],[13],[1,\"\\n  \"],[10,0],[14,0,\"cCH--loading cCH--loading--line\"],[12],[13],[1,\"\\n  \"],[10,0],[14,0,\"cCH--loading cCH--loading--line\"],[12],[13],[1,\"\\n\"],[13],[1,\"\\n\"]],[],false,[]]",
    "moduleName": "@latermedia/ember-later-analytics/components/ui/meter-list-loading.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});